import { memo } from 'preact/compat'
import { useRef, useEffect } from 'preact/hooks'
import { loadDispatcher } from '../utils'
import { useAppContext } from '../contexts/AppContext'

const ActionCard = ({ setIsAcReady }) => {
  const context = useAppContext()
  const headersCount = context ? context.headersCount : null
  const acRef = useRef(null)

  loadDispatcher.loadCallback ??= data => {
    if (headersCount === 1 && data.sections.length && data.sections[0].type === 'Separator') {
      // hide single separator if it comes first
      var sheet = new CSSStyleSheet()
      sheet.replaceSync(`[data-type="Separator"] { display: none }`)
      acRef.current.shadowRoot.adoptedStyleSheets.push(sheet)
    }
  }

  useEffect(() => {
    setIsAcReady?.(true)
  }, [])

  return (
    <action-cards
      className={context?.viewMode === 'funnel' ? '' : 'w-full'}
      ref={ref => {
        acRef.current = ref
        context.acRootRef.current = ref
      }}
    ></action-cards>
  )
}

export default memo(ActionCard)
